import { GlobalLinksKeys } from "../../../constants/types";
import { StoreApi } from "../types";

export const getGlobalLink = (pageKey: GlobalLinksKeys) => ({ getState }: StoreApi) => {
    const state = getState();
    const page = state.global.acf?.global_links[pageKey];

    if (page) {
        return page;
    }

    throw new Error(`Page not mapped in backend: ${pageKey}`);
};

export const setRegionSelectVisibility = (showingRegionSelect: boolean) => ({ setState }: StoreApi) => {
    // Remove query params
    window.history.pushState({}, document.title, window.location.pathname);
    setState({ showingRegionSelect });
};